// Loading skeleton for embedded-frame pages (dashboard, sales tracking).
// Keep in sync with Components::Skeletons::Frame (Phlex).

import { Bar, DEFAULT_LABEL, PageShell } from './primitives';

export function FrameSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <header className="flex-shrink-0 h-23 border-b border-dinnerplate-white">
        <div className="flex h-full w-full items-center px-16">
          <Bar className="h-5 w-[88px]" />
        </div>
      </header>
      <div className="flex-1 min-h-0 px-16 py-8">
        <div className="grid grid-rows-[auto,1fr] gap-0 rounded-lg overflow-hidden border shadow-sm h-full">
          <div className="px-6 py-3 border-b border-gray-200 flex items-center justify-between">
            <Bar className="h-4 w-36" />
            <Bar className="h-4 w-40" />
          </div>
          <div />
        </div>
      </div>
    </PageShell>
  );
}
